module.exports = "<section class=\"review-listing js-top-reviews\">\r\n    <div class=\"row flex-flow-sm\">\r\n        <div tabindex=\"-1\" ng-repeat=\"review in reviews\" class=\"col-sm-6 col-xs-12 flex-basis-mobile\">\r\n            <wow-review-card review=\"review\"></wow-review-card>\r\n        </div>\r\n    </div>\r\n</section>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/customer-reviews/list-review/review-listing-template.html
 ** module id = 924
 ** module chunks = 1
 **/